import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import Img from "react-cool-img";

import Button from '../../Button/Button';
// import GroupListControllContents from './GroupListControllContents';
import GroupListControlFavorite from './GroupListControlFavorite';
import GroupAcceptQRScan from "../GroupInvitation/GroupAcceptQRScan";

import GroupInfoModal from '../GroupInfo/GroupInfoModal';

import { useStore } from '../../../hook-store/store';

import { marks } from '../../../images/marks';
import classes from './GroupListControll.module.css'


const GroupListControll = (props) => {
  // console.log('GroupListControll-props', props);

  const { 
    groupList,
    showGroupTalkTextHandler,
    getGroupInfoHandler,
    editFavoriteGroupsHandler,
    editFavoriteGroupsResult,
    groupUserInfo,
    setShowAuthModal,
    createGroupStartHandler,
    isLoading,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  const [showGroupListControllModal, setShowGroupListControllModal] = useState('');
  const [showAcceptQRScan, setShowAcceptQRScan] = useState(false);


  const showGroupListControllModalHandler = () => {
    setShowGroupListControllModal(!showGroupListControllModal);
  }


  const groupListControllContents = (
    <div>
      {/* <GroupListControllContents
        groupList={groupList}
        groupUserInfo={groupUserInfo}
        showGroupTalkTextHandler={showGroupTalkTextHandler}
        getGroupInfoHandler={getGroupInfoHandler}
        editFavoriteGroupsHandler={editFavoriteGroupsHandler}
        editFavoriteGroupsResult={editFavoriteGroupsResult}
        isLoading={isLoading}
      /> */}
      <div className={classes.groupListControlRow}>
        <GroupListControlFavorite 
          groupList={groupList}
          groupUserInfo={groupUserInfo}
          showGroupTalkTextHandler={showGroupTalkTextHandler}
          getGroupInfoHandler={getGroupInfoHandler}
          editFavoriteGroupsHandler={editFavoriteGroupsHandler}
          editFavoriteGroupsResult={editFavoriteGroupsResult}
          isLoading={isLoading}
        />
      </div>
      <div className={classes.groupListControlRow}>
        <div>
          <span
            onClick={() => {
              setShowAcceptQRScan(!showAcceptQRScan);
            }}
          >
            {t('groupTalk.text99', 'QR code scanner')}
            {' '}{marks.qrcode} {marks.triangleDown}
          </span>
        </div>
      
        {showAcceptQRScan && isAuth && (
          <div>
            <GroupAcceptQRScan />
          </div>
        )}
        {showAcceptQRScan && !isAuth && (
          <div>
            Login is required
          </div>
        )}
      </div>
      <div className={classes.groupListControlRow}
        style={{textAlign: "right"}}
      >
        <Button mode="raised" type="submit" size="smaller"
          onClick={() => { 
            if (!isAuth) {
              setShowAuthModal(true);
            } else {
              createGroupStartHandler() 
            }
          }}
        >
          {/* Create Group */}
          {t('groupTalk.text13')}
        </Button>
      </div>

    </div>
  );

  let infoButtonBody;

  const infoButton = (      
    <div className={classes.infoButton}>
      <span className={classes.infoButtonMark}
        onClick={showGroupListControllModalHandler}
      >
        &#9881; 
        {/* ⚙️ */}
      </span>
    </div>
  );
 
  infoButtonBody = (
    <div>
      
      {!isLoading && infoButton}

      {showGroupListControllModal && 
        <GroupInfoModal 
          showModalHandler={showGroupListControllModalHandler}
          modalContent={groupListControllContents}
        />
      }
    </div>
  );


  return (
    <Fragment>
      {infoButtonBody}
    </Fragment>
  );
}

export default GroupListControll;